module.exports = __webpack_public_path__ + "static/level-10-logo.3fcc1c01.png";